import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { connect } from "react-redux";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "mapbox-gl-geocoder";
import { point, distance } from "@turf/turf";
import axios, { CancelToken } from "axios";

import { I18n } from "react-redux-i18n";

import { MAPBOX_TOKEN } from "../../utils/Utils";

import { setAlert } from "../../../actions/alertActions";

import ChargerTitle from "../../map/chargerInfo/ChargerTitle";

import "mapbox-gl/dist/mapbox-gl.css";
import "mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "../../../styles/components/utils/components/MapPicker.scss";

mapboxgl.accessToken = MAPBOX_TOKEN;

const PLUG_STATUS = {
  AVAILABLE: "10",
  IN_USE: "20",
  BOOKED: "30",
};

class MapPicker extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      index: 0,

      map: null,
      geocoder: null,
      gcInput: "",
      gcInputFocus: false,
      gcHistory: [],
      geojson: null,
      lat: 41.172707,
      lng: -8.680059,
      zoom: 14,

      stations: [],
      totalEvioStations: 0,
      selectedCharger: null,

      geolocated: false,
      geoLat: 0,
      geoLng: 0,

      direction: null,
      startLat: 0,
      startLng: 0,
      visibleDistance: 2000, // in meters
    };

    this.initializeMap = this.initializeMap.bind(this);
    this.queryGeocoder = this.queryGeocoder.bind(this);
    this.getUserLocation = this.getUserLocation.bind(this);
    this.loadMarkers = this.loadMarkers.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChargerClick = this.handleChargerClick.bind(this);
    this.createMarkerElement = this.createMarkerElement.bind(this);
    this.createPopupElement = this.createPopupElement.bind(this);
    this.resetSelectedMarkers = this.resetSelectedMarkers.bind(this);
    this.resetPopups = this.resetPopups.bind(this);
    this.fetchStations = this.fetchStations.bind(this);
    this.updateCoords = this.updateCoords.bind(this);
    this.updateZoom = this.updateZoom.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.getHomeLocation();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting.");
  }

  getUserLocation(position) {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    this.safeSetState(
      {
        lat: lat,
        lng: lng,
        geolocated: true,
        geoLat: lat,
        geoLng: lng,
      },
      () => this.initializeMap()
    );
  }

  getHomeLocation() {
    const idx = this.props.places
      ? this.props.places.findIndex((p) => p.name === "home")
      : -1;

    if (idx !== -1) {
      const coords = this.props.places[idx].geometry.coordinates;

      this.safeSetState(
        { lng: coords[0], lat: coords[1], zoom: 15 },
        this.initializeMap
      );
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.getUserLocation,
        this.initializeMap
      );
    } else {
      this.initializeMap();
    }
  }

  initializeMap() {
    this.safeSetState(
      {
        map: new mapboxgl.Map({
          container: this.mapContainer,
          style: "mapbox://styles/evioadmin/ck9n0oy82423g1inp0fngkjlr",
          center: [this.state.lng, this.state.lat],
          zoom: this.state.zoom,
          attributionControl: false,
        }).addControl(new mapboxgl.AttributionControl()),
        geocoder: new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          placeholder: I18n.t("map_searchLocation"),
          localGeocoder: this.addQueryToHistory,
        }),
      },
      () => {
        const fc = document.getElementById("filters-container");
        const gc = this.state.geocoder.onAdd(this.state.map);
        fc.insertBefore(gc, fc.firstChild);
        this.state.geocoder._inputEl.addEventListener("focus", (e) => {
          this.safeSetState({
            gcInputFocus: true,
          });
        });
        this.state.geocoder._inputEl.addEventListener("blur", (e) => {
          this.safeSetState({
            gcInputFocus: false,
          });
        });
        this.state.geocoder._inputEl.addEventListener("keyup", (e) => {
          this.safeSetState({
            gcInput: e.target.value,
          });
        });

        this.state.map.on("load", () => {
          this.fetchStations(
            this.state.lat,
            this.state.lng,
            this.state.visibleDistance,
            this.state.filters
          );
        });

        this.state.map.on("move", () => {
          const lat = this.state.map.getCenter().lat.toFixed(4);
          const lng = this.state.map.getCenter().lng.toFixed(4);
          this.updateCoords(lat, lng);

          const zoom = this.state.map.getZoom().toFixed(2);
          if (zoom !== this.props.zoom) this.updateZoom(zoom);
        });

        this.state.map.on("movestart", (data) => {});

        this.state.map.on("moveend", (data) => {
          this.safeSetState(
            {
              visibleDistance:
                this.calculateDistanceVisible(data.target.transform.center) *
                1000,
            },
            () => {
              if (this.mapShouldUpdate(data.target.transform.center)) {
                this.fetchStations(
                  this.state.lat,
                  this.state.lng,
                  this.state.visibleDistance
                );
              }
            }
          );
        });

        this.state.map.on("click", (data) => {
          this.safeSetState(
            {
              selectedCharger: null,
              sidebar: false,
            },
            () => {
              this.resetSelectedMarkers();
              setTimeout(() => this.state.map.resize(), 1000);
            }
          );
        });
      }
    );
  }

  queryGeocoder(e, query) {
    this.state.geocoder.query(query);
  }

  calculateDistanceVisible(center) {
    const bounds = this.state.map.getBounds();
    let from = point([bounds._sw.lng, bounds._sw.lat]);
    let to = point([center.lng, center.lat]);
    return distance(from, to, { units: "kilometers" });
  }

  calculateDistanceTraveled(center) {
    let from = point([this.state.startLng, this.state.startLat]);
    let to = point([center.lng, center.lat]);
    return distance(from, to, { units: "kilometers" });
  }

  mapShouldUpdate(center) {
    let dT = this.calculateDistanceTraveled(center);
    if (dT > 1 && this.state.zoom >= 9) return true;
    else return false;
  }

  loadMarkers() {
    if (typeof this.state.map.getSource("chargers") !== "undefined") {
      this.state.map.removeSource("chargers");
    }
    this.state.map.addSource("chargers", {
      type: "geojson",
      data: this.state.geojson,
    });

    this.state.geojson.features.map((marker, idx) => {
      const el = this.createMarkerElement(marker, idx);
      const popup = this.createPopupElement(marker);
      const obj = new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .setPopup(new mapboxgl.Popup({ offset: 25 }).setDOMContent(popup))
        .addTo(this.state.map);

      this.safeSetState((prevState) => ({
        geojson: Object.assign({}, this.state.geojson, {
          features: [
            ...prevState.geojson.features.slice(0, idx),
            Object.assign({}, marker, { markerObj: obj }),
            ...prevState.geojson.features.slice(idx + 1),
          ],
        }),
      }));
      return obj;
    });
  }

  removeMarkers() {
    // clear markers from map
    let markers = Array.from(
      document.getElementsByClassName("mapboxgl-marker")
    );
    if (markers) markers.map((m) => m.remove());
  }

  handleChargerClick(e, marker, idx) {
    e.stopPropagation();
    this.resetSelectedMarkers();

    // show popup and display button for adding to compare

    this.state.map.flyTo({
      center: marker.geometry.coordinates,
      zoom: 15,
    });
    this.resetPopups();
    this.state.geojson.features[idx].markerObj.togglePopup();
  }

  handleSelect(selectedIndex, e) {
    this.safeSetState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  createMarkerElement(marker, idx) {
    // create a HTML element for each feature
    var el = document.createElement("div");
    el.className = "marker ";

    if (
      marker.properties.hasOwnProperty("chargerType") &&
      marker.properties.chargerType === "009"
    ) {
      el.className += "tesla ";
    } else if (
      marker.properties.hasOwnProperty("accessType") &&
      marker.properties.hasOwnProperty("createUser")
    ) {
      if (marker.properties.createUser === this.props.accountData.id) {
        el.className += "private ";
      } else {
        el.className += "evio ";
        this.safeSetState((prevState) => ({
          totalEvioStations: prevState.totalEvioStations + 1,
        }));
      }
    } else el.className += "public ";

    if (
      marker.properties.status === PLUG_STATUS.IN_USE ||
      marker.properties.status === PLUG_STATUS.BOOKED
    ) {
      el.className += "busy ";
    } else if (marker.properties.status === PLUG_STATUS.OFFLINE)
      el.className += "offline ";
    else el.className += "available ";

    if (this.state.selectedCharger !== null) {
      if (marker.properties._id === this.state.selectedCharger.properties._id) {
        el.classList.add("selected");
      }
    }
    el.addEventListener("click", (e) =>
      this.handleChargerClick(e, marker, idx)
    );
    return el;
  }

  createPopupElement(marker) {
    const el = document.createElement("div");
    ReactDOM.render(
      <ChargerTitle charger={marker} compareBtn={this.props.onPick} />,
      el
    );
    return el;
  }

  resetSelectedMarkers() {
    const markers = document.getElementsByClassName("marker");
    Array.from(markers).forEach((marker) => {
      marker.classList.remove("selected");
    });
  }

  resetPopups() {
    $(this.state.map.getCanvas()).trigger("click");
  }

  fetchStations() {
    this.safeSetState({
      startLat: this.state.lat,
      startLng: this.state.lng,
    });

    if (this.cancel) this.cancel("New request was made.");
    return axios
      .post("/api/public/connectionstation/chargers", null, {
        params: {
          lat: this.state.lat,
          lng: this.state.lng,
          distance: this.state.visibleDistance,
        },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        res.data.map((station, i) => {
          let plugsBusy = 0;

          station.hasOwnProperty("plugs") &&
            station.plugs.map((plug) => {
              if (
                plug.status === PLUG_STATUS.IN_USE ||
                plug.status === PLUG_STATUS.BOOKED
              )
                plugsBusy++;
              return plug;
            });

          let status;
          if (plugsBusy === station.plugs.length) status = PLUG_STATUS.IN_USE;
          else status = PLUG_STATUS.AVAILABLE;

          res.data[i].status = status;
          return station;
        });

        this.safeSetState(
          {
            stations: res.data,
          },
          () => {
            this.safeSetState(
              {
                geojson: {
                  type: "FeatureCollection",
                  features: this.state.stations.map((station) => {
                    return {
                      type: "Feature",
                      properties: station,
                      geometry: {
                        type: "Point",
                        coordinates: [
                          station.geometry.coordinates[0],
                          station.geometry.coordinates[1],
                        ],
                      },
                    };
                  }),
                },
              },
              () => {
                this.removeMarkers();
                this.loadMarkers();
              }
            );
          }
        );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  updateCoords(lat, lng) {
    this.safeSetState({
      lat: lat,
      lng: lng,
    });
  }

  updateZoom(zoom) {
    this.safeSetState({ zoom: zoom });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="mapPicker" className={"map-overview"}>
        {this.state.selectedCharger !== null && (
          <div className="map-backdrop" />
        )}
        <div
          ref={(el) => (this.mapContainer = el)}
          className={
            this.props.fullscreen
              ? "mapContainer mapboxgl-map fullscreen"
              : "mapContainer mapboxgl-map"
          }
        >
          <div id="filters-container" className="filters-container" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  places: state.account.accountData.places,
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, { setAlert })(MapPicker);
